import { render, staticRenderFns } from "./kp.vue?vue&type=template&id=e8d2fdb8"
import script from "./kp.vue?vue&type=script&lang=js"
export * from "./kp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports